import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { get } from 'lodash';
import React, { FC } from 'react';
import { EINREICHUNG_DER_UNTERLAGEN } from 'src/lib/constants/constant';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const PostVersandInfo: FC<{ application: any }> = ({ application }) => {
	// const antragsFormular = get(application, P.Allgemein_Antragsformular.path, '');

	const EinreichungDerUnterlagen = get(application, P.Foerderprogramm.schema.attributes.Konfiguration_Einreichung_Der_Antragsunterlagen.path, '');

	if (EinreichungDerUnterlagen === EINREICHUNG_DER_UNTERLAGEN.postalisch) {
		return (
			<>
				<Divider sx={{ borderColor: '#000', mt: '2rem' }} />
				<Stack spacing={3} sx={{ mt: '1rem' }}>
					<Typography variant={'h5'} component={'p'} sx={{ fontWeight: 600 }}>
						Einreichung der KMU-Selbsterklärung
					</Typography>
					<Typography>
						Die KMU-Selbsterklärung ist Bestandteil des Förderantrags. Bitte lassen Sie uns die handschriftlich unterzeichnete
						KMU-Selbsterklärung und einen Ausdruck der ausgefüllten KMU-Selbsterklärung-Berechnung - zusammen mit den weiteren Antragsdokumenten
						- fristgerecht im Original zukommen.
					</Typography>
					<Box sx={{ mb: '5rem !important' }}>{/*Platzhalter element*/}</Box>
				</Stack>
			</>
		);
	} else {
		return (
			<>
				<Divider sx={{ borderColor: '#000', mt: '2rem' }} />
				<Stack spacing={3} sx={{ mt: '1rem' }}>
					<Typography>
						<strong>Wichtig:</strong> Die unterzeichnete KMU-Selbsterklärung ist Bestandteil des Förderantrags. Der Upload der Erklärung an
						dieser Stelle ist daher wichtig für die Einreichung Ihres vollständigen Antrags auf Förderung.
					</Typography>
					<Box sx={{ mb: '5rem !important' }}>{/*Platzhalter element*/}</Box>
				</Stack>
			</>
		);
	}
};
export default PostVersandInfo;
